import { useMemo } from 'react';
import { type TermSettingsPayload } from '../../../../../../api';

export const useTerms = (termSettings: TermSettingsPayload): number[] =>
    useMemo(() => {
        if (!termSettings) {
            return [];
        }

        const { min: termMin, max: termMax, step: termStep } = termSettings;
        if (!Number.isFinite(termMin) || !Number.isFinite(termMax) || !Number.isFinite(termStep)) {
            return [];
        }

        const results = [];
        for (let term = termMin; term <= termMax; term += termStep) {
            results.push(term);
        }

        return results;
    }, [termSettings]);

export default useTerms;
